<div class="auth-wrapper">
	<div class="auth-shell" [class.right-panel-active]="isSignUpMode">
		<div class="auth-container">
			<div class="form-container sign-up-container">
				<form class="auth-form" novalidate>
					<img class="logo" src="assets/img/logo-sistema.png" alt="Sistemas" (click)="redirectToSistemas()" />
					<h1>Crie sua conta</h1>
					<span class="sub-text">[Cadastro disponível em breve]</span>

					<div class="custom-input-group">
						<input class="custom-input" type="text" placeholder="Nome completo" />
					</div>

					<div class="custom-input-group">
						<input class="custom-input" type="text" placeholder="CPF" />
					</div>

					<div class="custom-input-group">
						<input class="custom-input" type="email" placeholder="Email" />
					</div>

					<div class="custom-input-group">
						<input class="custom-input" type="password" placeholder="Senha" />
					</div>

					<button type="button" class="submit" (click)="onFakeSignUp()" disabled>
						Cadastrar (em breve)
					</button>

					<button type="button" class="ghost mobile-alt-action" (click)="showSignIn()">Login</button>
				</form>
			</div>

			<div class="form-container sign-in-container">
				<form class="auth-form" [formGroup]="loginFormGroup" novalidate>
					<img class="logo" src="assets/img/logo-sistema.png" alt="Sistemas" (click)="redirectToSistemas()" />
					<h1>Entrar</h1>
					<span class="sub-text">Use seu CPF e senha para continuar</span>

					<div *ngIf="errStr" class="error-msg">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
							<path
								d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
						</svg>
						<span class="txterror">{{ errStr }}</span>
					</div>

					<div class="custom-input-group">
						<input class="custom-input" type="text" placeholder="CPF" formControlName="user" />
					</div>

					<div class="custom-input-group">
						<input class="custom-input" [type]="hidePassword ? 'password' : 'text'" placeholder="Senha" formControlName="pass" />
						<button class="password-toggle" (click)="togglePasswordVisibility()" type="button" tabindex="-1">
							<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
						</button>
					</div>

					<a class="forgot-link" (click)="onClickEsqueci()">Esqueci a Senha</a>

					<div class="login-actions">
						<button
							type="submit"
							class="submit"
							[disabled]="loginFormGroup.invalid || !!subscription"
							(click)="onLogin()">
							<span *ngIf="!subscription">Entrar</span>
							<span *ngIf="subscription" class="loading-row">
								<mat-spinner [diameter]="18"></mat-spinner>
								Entrando...
							</span>
						</button>

						<button type="button" class="ghost mobile-alt-action" (click)="showSignUp()">Cadastro</button>
					</div>
				</form>
			</div>

			<div class="overlay-container">
				<div class="overlay">
					<div class="overlay-panel overlay-left">
						<h1>Já possui conta?</h1>
						<p>Entre com suas credenciais para acessar o sistema.</p>
						<button class="ghost" type="button" (click)="showSignIn()">Entrar</button>
					</div>
					<div class="overlay-panel overlay-right">
						<h1>Novo por aqui?</h1>
						<p>Crie sua conta para acessar o sistema.</p>
						<button class="ghost" type="button" (click)="showSignUp()">Criar conta</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>